import { useLayoutEffect, useState, type ReactNode } from 'react';
import { Provider, useSelector } from 'react-redux';
import { bindCommonStore } from '@qcdoc/shared/services/auth/bootstrap.ts';
import type { CommonState } from '@qcdoc/shared/redux/selectors/commonSelectors.ts';
import { createAppStore } from './index.ts';

function SessionBoundary({ children }: { children: ReactNode }) {
  const identity = useSelector((state: CommonState) => JSON.stringify([state.auth.user?.portal, state.auth.user?.sub]));
  return <div key={identity} style={{ display: 'contents' }}>{children}</div>;
}

export function AppStateProvider({ children }: { children: ReactNode }) {
  const [store] = useState(createAppStore);
  useLayoutEffect(() => bindCommonStore(store), [store]);
  return <Provider store={store}><SessionBoundary>{children}</SessionBoundary></Provider>;
}